// Shared metrics for the sheet behind the task-detail barcode button. Each
// platform styles the sheet with its own LIGHT design tokens: the sheet never
// follows the active theme, since a barcode needs a bright surface to scan.

/**
 * Letter spacing in px for the caption and the digits line. The digits are
 * keyed in by hand off the screen, so they are spaced to be grouped by eye.
 */
export const BARCODE_SHEET_METRICS = {
  captionTracking: 1.5,
  digitsTracking: 2,
};
